<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-search_box" :style="search_box_Style">
      <div class="dft-search_keys" :style="search_keys_style">
        <div class="dft-search_icon" :style="search_icon_style">
          <!-- uniapp -->
          <i class="el-icon-message-solid"></i>
        </div>
        <div class="dft-search_key">
          {{noticeText}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
        type: [Array,Object],
        default: ()=>[]
    },
  },
		options: {
			styleIsolation: 'shared', // 解除样式隔离
		},
  data () {
    return {
      showDialog: false,
    };
  },
  watch:{
    compData: {
      handler: function(newVal){
        if(newVal){
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          });
        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    //数据
    noticeText(){
      return this.compData?.attr?.a1?.value
    },
    iconcolor(){
      return this.compData?.attr?.a3?.value == '1'
    },
    // 样式
    container_Style(){
      return {
        'padding': `${this.compData?.attr?.['a8']?.value} ${this.compData?.attr?.['a9']?.value}px`,
        'background': this.compData?.attr?.['a6']?.value,
      }
    },
    search_box_Style(){
      return {
        'background': this.compData?.attr?.['a2']?.value,
        'border-radius': this.compData?.attr?.['a7']?.value,
        'height': `${this.compData?.attr?.['a10']?.value}px`,
      }
    },
    search_icon_style(){
      return {
        'color': this.iconcolor?this.compData?.attr?.['a5']?.value:this.compData?.attr?.['a4']?.value,
      }
    },
    search_keys_style(){
      return {
        'color': this.compData?.attr?.['a5']?.value,
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  height: auto;
  box-sizing: border-box;
}
.dft-search_box{
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  font-size: 14px;
}
.dft-search_keys{
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  .dft-search_icon{
    padding: 0 6px;
  }
}
</style>

